export const Roles = Object.freeze({
  ADMIN: "ADMIN",
  MANAGER: "MANAGER",
  SUPER_ADMIN: "SUPER_ADMIN",
  SALES_EXECUTIVE: "SALES_EXECUTIVE",
  SENIOR_SALES_EXECUTIVE: "SENIOR_SALES_EXECUTIVE",
});
